export const removeUserDataFromBrowserStorage = ()=>{
    let keysToRemove = [
        'user',
        'user_type',
    ];

    for (let key of keysToRemove) {
        localStorage.removeItem(key);
    }
}